import { Constants, normalizeSDGElement } from "@eagerdog/constants";
import { IShow } from "@eagerdog/interfaces";
import { IEventRegisterRow } from "../../../services/helper.service.js";

const allSectionOptions = [
  { value: Constants.dog_class_section.sdg_level_1, id: Constants.dog_class_section.sdg_level_1 },
  { value: Constants.dog_class_section.sdg_level_2, id: Constants.dog_class_section.sdg_level_2 },
];

function sdgRow(levelConstant: string, show?: IShow): IEventRegisterRow {
  const useSections = !!(show?.show_elements?.some(se => se.section));

  const inputs: IEventRegisterRow["inputs"] = [
    {
      type: "checkbox",
      multiSelect: true,
      label: Constants.show_type.scent_dog_games,
      options: [{ value: levelConstant, id: levelConstant }],
    },
  ];

  if (useSections) {
    // Only offer sections that are actually configured for this level on the show.
    // If the organizer only enabled Level 1, Level 2 must not appear as an option.
    const configuredSections = show?.show_elements
      ?.filter(se => normalizeSDGElement(se.level ?? "") === levelConstant)
      .map(se => se.section)
      .filter(Boolean) as string[] | undefined;

    const sectionOptions = configuredSections?.length
      ? allSectionOptions.filter(opt => configuredSections.includes(opt.id))
      : allSectionOptions;

    // Default to the first available section so the dropdown always has a valid value.
    const defaultSection = sectionOptions[0]?.id ?? Constants.dog_class_section.sdg_level_1;

    inputs.push({
      type: "dropdown",
      defaultValue: defaultSection,
      label: "Section",
      // sdgLevelConstant lets dupCheckOptions filter out already-used sections when
      // the user adds a duplicate row via the + button.
      sdgLevelConstant: levelConstant,
      options: sectionOptions,
    } as any);
  }

  return { inputs, allowDuplicates: true };
}

export namespace ABIScentDogGames {
  export function getForm(show?: IShow): IEventRegisterRow[] {
    return [
      sdgRow(Constants.dog_class_element_level.sdg_once_around, show),
      sdgRow(Constants.dog_class_element_level.sdg_double_or_nothing, show),
      sdgRow(Constants.dog_class_element_level.sdg_clear_it, show),
      sdgRow(Constants.dog_class_element_level.sdg_duo, show),
      sdgRow(Constants.dog_class_element_level.sdg_teams, show),
      sdgRow(Constants.dog_class_element_level.sdg_against_odds, show),
      sdgRow(Constants.dog_class_element_level.sdg_hi_lo, show),
      sdgRow(Constants.dog_class_element_level.sdg_double_0_7, show),
      sdgRow(Constants.dog_class_element_level.sdg_at_distance, show),
      sdgRow(Constants.dog_class_element_level.sdg_relay_race, show),
      sdgRow(Constants.dog_class_element_level.sdg_cluster, show),
      sdgRow(Constants.dog_class_element_level.sdg_hit_the_wall, show),
      sdgRow(Constants.dog_class_element_level.sdg_twice_around_foundations, show),
      sdgRow(Constants.dog_class_element_level.sdg_clear_it_foundations, show),
      sdgRow(Constants.dog_class_element_level.sdg_cluster_foundations, show),
      sdgRow(Constants.dog_class_element_level.sdg_hi_lo_foundations, show),
      sdgRow(Constants.dog_class_element_level.sdg_hit_the_wall_foundations, show),
    ];
  }

  // Keep a static `form` export for backward compat (no sections)
  export const form = getForm(undefined);
}
